import { Action, Reducer } from "redux";
import { ParameterActionTypes, ParameterState, ParameterTypes } from "./parameterTypes";

export const INITIAL_STATE: ParameterState = {
	parameters: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
	parameterByTypeAndCompany: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
};

const parameterReducer: Reducer<ParameterState> = (state: ParameterState = INITIAL_STATE, action: Action) => {
	const actionTypes = action as ParameterActionTypes;
	switch (actionTypes.type) {
		case ParameterTypes.GET_PARAMETERS:
			return {
				...state,
				parameters: { ...state.parameters, isLoading: true },
			};
		case ParameterTypes.SAVE_PARAMETERS:
			return {
				...state,
				parameters: {
					...state.parameters,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		case ParameterTypes.RESET_REDUCER_PARAMETERS:
			return {
				...state,
				parameters: INITIAL_STATE.parameters,
			};
		case ParameterTypes.GET_PARAMETER_BY_TYPE_AND_COMPANY:
			return {
				...state,
				parameterByTypeAndCompany: {
					...state.parameterByTypeAndCompany,
					isLoading: true,
				},
			};
		case ParameterTypes.SAVE_PARAMETER_BY_TYPE_AND_COMPANY:
			return {
				...state,
				parameterByTypeAndCompany: {
					...state.parameterByTypeAndCompany,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		case ParameterTypes.RESET_REDUCER_PARAMETER_BY_TYPE_AND_COMPANY:
			return {
				...state,
				parameterByTypeAndCompany: INITIAL_STATE.parameterByTypeAndCompany,
			};
		default:
			return state;
	}
};

export default parameterReducer;
